import { HERO_IMAGE } from "@/data/products";

export const Hero = () => {
  return (
    <header
      id="top"
      data-testid="hero-section"
      className="px-6 pt-16 pb-20 md:py-24 max-w-6xl mx-auto border-b border-[var(--line)]"
    >
      <div className="text-center max-w-3xl mx-auto">
        <div className="label-caps text-[11px] text-[var(--ink)]/70 mb-4 inline-flex items-center gap-3">
          <span>HYDRATE</span>
          <span className="opacity-40">|</span>
          <span>REFRESH</span>
          <span className="opacity-40">|</span>
          <span>ATTRACT</span>
        </div>

        <h1 className="serif-head text-4xl sm:text-6xl lg:text-7xl leading-[1.05] text-[var(--ink)] mt-2 mb-6">
          <span className="ln">
            <span>Pheromone Perfumed</span>
          </span>
          <span className="ln">
            <span>Moisturizing Skin Spray</span>
          </span>
        </h1>

        <div className="w-16 h-[1px] bg-[var(--line-strong)] mx-auto mb-6"></div>

        <p className="text-sm sm:text-base text-[var(--ink)]/80 max-w-xl mx-auto font-light leading-relaxed dr1-fade">
          Express Yourself Naturally. An all-natural formula with no harsh chemicals, balancing
          botanical moisture with magnetic skin presence.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 dr1-fade">
          <a
            href="#scents"
            data-testid="hero-select-scent-cta"
            className="border border-[var(--ink)] bg-[var(--ink)] text-[var(--bg)] px-8 py-3.5 label-caps text-[11px] hover:bg-transparent hover:text-[var(--ink)] transition-colors"
          >
            Select Fragrance &bull; $68
          </a>
          <span className="label-caps text-[10px] text-[var(--ink)]/60">
            Shake well before use &bull; Made in Canada
          </span>
        </div>
      </div>

      {/* Hero Label Visual — the real Bare Essentials label */}
      <div className="mt-14 max-w-2xl mx-auto">
        <div className="relative aspect-[6/5] border border-[var(--line)] overflow-hidden bg-[var(--card-bg)]">
          <img
            src={HERO_IMAGE}
            alt="Bare Essentials label — Pheromone Perfumed Moisturizing Skin Spray, Made in Canada"
            data-testid="hero-image"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute bottom-4 right-4 border border-[var(--ink)]/20 bg-[var(--bg)]/85 backdrop-blur-sm px-4 py-2.5 text-right">
            <div className="label-caps text-[9px] text-[var(--ink)]">All-Natural Formula</div>
            <div className="mono-num text-xs text-[var(--ink)]/70 mt-0.5" data-testid="hero-price">
              $68.00 USD
            </div>
          </div>
        </div>
        <p className="mt-3 text-center label-caps text-[9px] text-[var(--ink)]/50">
          The label on every bottle
        </p>
      </div>
    </header>
  );
};
